export class NeoSolicitudNegada {
  constructor(
    public idSolicitud: String,
    public idCliente: Number,
    public id_tipo_negacion: Number,
    public idUsuario: Number,
    public observaciones?: String
  ) {}
}
